import Util from './util';


const cls = Util.cls;
const config = {
    sel: {
        wrapContent: '#wrap-content',
        wrapContentBlurred: '.blurred',
        spinner: '.spinner',
        spinnerVisible: '.spinner_visible'
    },
};

let isVisible = false;

function toggle(state = null) {
    if (Util.isNull(state)) state = !isVisible;
    $(config.sel.wrapContent).toggleClass(cls(config.sel.wrapContentBlurred), state);
    $(config.sel.spinner).toggleClass(cls(config.sel.spinnerVisible), state);
}

const show = () => toggle(true);
const hide = () => toggle(false);


export default {
    show,
    hide
}
